import getCollection from './getCollection'
import { startOfDay, endOfDay, eachDayOfInterval, lightFormat, max, isSameDay } from 'date-fns'
import XLSX from 'xlsx'
import { fieldLabels, fieldNames } from 'utils/fields'
import getProps from 'utils/getProps'
import { where, query, getDocs, orderBy } from 'firebase/firestore/lite'
import getPaymentGateway from 'utils/getPaymentGateway'

const exportBooking = async ({ slotId, status = [], startDate, endDate = startDate }) => {
  const format = 'ddMMyyyy'
  const snapshot = await getDocs(
    query(
      getCollection(),
      where('slot.id', '==', slotId),
      where('start', '>=', startOfDay(startDate)),
      where('start', '<=', endOfDay(max([endDate, startDate]))),
      where(
        'status',
        'in',
        status.map((s) => s.value)
      ),
      orderBy('start')
    )
  )

  const wb = XLSX.utils.book_new()
  let ws = {}

  const writeToSheet = (day) => {
    const sheetName = lightFormat(day, format)
    ws[sheetName] = XLSX.utils.json_to_sheet([], {
      header: [
        'Booking ID',
        'Status',
        'Time',
        'Fee Name',
        'Paid Amount',
        'Paid Currency',
        'Paid By',
        'Transaction Id',
        'Name',
        'Email',
        'Phone',
      ].concat(fieldLabels),
    })
    XLSX.utils.book_append_sheet(wb, ws[sheetName], sheetName)
    return null
  }

  if (isSameDay(startDate, endDate)) {
    writeToSheet(startDate)
  } else {
    eachDayOfInterval({ start: startDate, end: endDate }).map(writeToSheet)
  }

  if (!snapshot.empty) {
    snapshot.docs.map((d) => {
      const booking = d.data()
      const sheetName = lightFormat(booking.start, format)
      const dataJson = {
        id: booking.id,
        status: booking.getStatus().label,
        date: booking.displayTime(true),
        fee: booking.fee?.name,
        amount: booking.paidAmount?.amount,
        currency: booking.paidAmount?.currency,
        gateway: getPaymentGateway(booking.paidAmount?.gateway, booking.paidAmount?.method)?.name,
        transactionId: booking.paidAmount?.transactionId,
        name: booking.name,
        email: booking.email,
        phone: booking.phone,
      }
      fieldNames.map((n) => (dataJson[n] = getProps(booking, n)))
      XLSX.utils.sheet_add_json(ws[sheetName], [dataJson], { skipHeader: true, origin: -1 })
      return null
    })
  }

  XLSX.writeFile(wb, `${lightFormat(startDate, format)}-${lightFormat(endDate, format)}.xlsx`)
}

export default exportBooking
